<template>
<div class="input-field" style="width: 100%">
  <div class="select-wrapper" style="width: 100%">
    <div  class="select-dropdown dropdown-trigger elongating" :data-target="'dropdownselector'+identifier" v-if="elongating" v-show="!disabled">
    <p v-for="ritem in ritems">{{ritem}}</p>
  </div>
  <div  class="elongating" v-if="elongating" v-show="disabled">
    <p v-for="ritem in ritems">{{ritem}}</p>
  </div>
     <input type="text" readonly="true" v-model="labels" v-if="disabled" v-show="!elongating"/>
   <div class="dropdown-trigger" :data-target="'dropdownselector'+identifier" v-show="!disabled">
    <input class="select-dropdown" type="text" readonly="true" v-model="labels" v-if="!disabled" v-show="!elongating"/>
    <i class="material-icons dp6 " style="top: 5px;position: absolute;right: 5px;z-index: 999;" >expand_more</i>
  </div>
  <div v-show="disabled">
    <input class="select-dropdown" type="text" readonly="true" v-model="labels" v-if="!disabled" v-show="!elongating"/>
    <i class="material-icons dp6 " style="top: 5px;position: absolute;right: 5px;z-index: 999;" >expand_more</i>
  </div>
  </div>
  <ul :id="'dropdownselector'+identifier" class='dropdown-content select-dropdown multiple-select-dropdown'>
    <li  class='searchterm'>
      <p><input v-model="searchterm"/></p>
    </li>
     <li>
        <span>
          <label>
            <input v-model="showall"  type="checkbox"/>
            <span>{{$t('menu.buttons.selectall')}}</span>
          </label>
        </span>
    </li>
    <li v-for="item in filteredItems" v-if="groupitems == undefined">
      <span>
      <label style="display: inline-flex;">
        <input :value="item.value"  v-model="selectionsLocal"  type="checkbox" checked="checked"  v-if="!singlemode" />
        <template v-if="singlemode">
          <p v-on:click="selectedItem(item)">{{item.name}}</p>
        </template>
        <span style="width: 100%;" v-if="!singlemode">{{item.name}}{{hasquantity(item.value)}}</span>
        <template v-if="hasquantity(item.value)"><input v-model="quantitiesdict[item.value].quantity"/></template>
      </label>
    </span>
    </li>
    
   <template v-for="group in filteredGroups" v-if="groupitems != undefined">
    <label>
      <span v-html="boldString(group.name, searchterm)"/>
    </label>
      <ul>
        <li v-for="item in group.items" tabindex="-1">

        <span>
        <label style="display: inline-flex;">
          <input :value="item.value"  v-model="selectionsLocal"  type="checkbox" checked="checked"  v-if="!singlemode" />
          <template v-if="singlemode">
            <p v-on:click="selectedItem(item)" v-html="boldString(item.name, searchterm)">{{item.name}}{{hasquantity(item.value)}}</p>
          </template>
          <span style="width: 100%;" v-if="!singlemode">{{item.name}}</span>
          <template v-if="hasquantity(item.value)"><input type="number" v-model="quantitiesdict[item.value].quantity"/></template>
        </label>
      </span>
    </li>
    </ul>
    </template>
  </ul>
</div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
    data: function () {
        return {
          searchterm: "",
          quantitiesdict: {},
          showall: false
        }
    },
    props: {
      selections: { type: [Array, Number], default() {
            return []
        }},
      pestquantities: { type: Array, default(){
        return []
      }},
      items: Array,
      identifier: String,
      disabled: Boolean,
      elongating: Boolean,
      singlemode: Boolean,
      groupitems: String,
      recommendations: Array
    },
    model: {
        prop: 'pestquantities',
        event: 'listchange'
    },
    mounted: function(){
      var elemss = this.$el.querySelectorAll('.dropdown-trigger');
      this.instance = M.Dropdown.init(elemss, {closeOnClick: false});
      this.quantitiesdict = _.keyBy(this.pestquantities, 'pest_id');
    },
    methods: {
      selectedItem(item){
        this.selectionsLocal = item.value;
        this.instance[0].close();
        
      },
      boldString(str, find){
        var re = new RegExp(find, 'gi');
        if(find.length > 0 && str.match(re) && str.match(re).length > 0){
          return str.replace(re, '<b>'+str.match(re)[0]+'</b>');
        }else{
          return str;
        }
      },
      hasquantity: function(pid){
        return _.keys(this.quantitiesdict).indexOf(''+pid) > -1;
      }
    },
  computed: {
    selectionsLocal: {
      get: function(){
        var selectionsFromQuantities = _.map(this.pestquantities, 'pest_id')
        return _.concat(this.selections, selectionsFromQuantities)
      },
      set: function(value){
        var selectionsFromQuantities = _.map(this.pestquantities, 'pest_id')
        var sels = _.concat(this.selections, selectionsFromQuantities)
        var added = _.difference(value, sels);
        for (var i = added.length - 1; i >= 0; i--) {
          if(_.keyBy(this.pestquantities, 'pest_id')[added[i]] == undefined){
            var quant = {pest_id: added[i], quantity: 1};
            this.pestquantities.push(quant);
            this.quantitiesdict[added[i]] = quant;
          }
        }
        var removed = _.difference(sels, value);
        for (var i = removed.length - 1; i >= 0; i--) {
          var item = _.keyBy(this.pestquantities, 'pest_id')[removed[i]];
          if(item != undefined){
            delete this.quantitiesdict[removed[i]];
            this.pestquantities = this.pestquantities.splice(this.pestquantities.indexOf(item), 1);
          }
        }
        this.$emit('listchange', this.pestquantities)
      }
    },
    ritems(){
      var lbs = _.zipObject(this.items.map(item => [item.value]), this.items.map(item => [item.name]))
      if(_.isUndefined(this.selectionsLocal)){
        return []
      }else return _.flatten(this.selectionsLocal.map(item => lbs[item]))
    },
    
    labels() {
      var lbs = {};
      if(this.groupitems == undefined){
        lbs = _.zipObject(this.items.map(item => [item.value]), this.items.map(item => [item.name]))
      }else{
        for (var i = this.items.length - 1; i >= 0; i--) {
          lbs = _.extend(lbs, _.zipObject(this.items[i].items.map(item => [item.id]), this.items[i].items.map(item => [item.name])))
        }
      }
      
      if(_.isUndefined(this.selectionsLocal)){
        return ""
      }else if(this.singlemode){
        var item = _.keyBy(_.flatten(_.map(this.items, this.groupitems)),'id')[this.selectionsLocal];
        if(_.isObject(item)) {return item.name;} else { return this.$t('menu.buttons.select') }
      }else{
        var mapa = _.keyBy(this.pestquantities, 'pest_id');
        if(this.pestquantities.length > 0){
          return _.compact(_.flatten(this.pestquantities.map(item => {
              if(item != undefined) {
                return lbs[item.pest_id]+" ("+item.quantity + " szt)";
              }
              else return lbs[item];
                }
              )
            )
          ).join(", ")
        }else if(this.selectionsLocal.length > 0){
          return selectionsLocal
        }else{
          return this.$t('menu.buttons.select')
        }
      }
    },
    filteredGroups: function() {
      var that = this;
      
      var imts = _.map(this.items, function(item){
          if(item instanceof Object){
            if(_.isUndefined(that.recommendations)){
              if(item.name.toLowerCase().indexOf(that.searchterm.toLowerCase()) !== -1){
                return {
                  name: item.name,
                  items: _.map(item[that.groupitems], function(subitem){
                    return {
                      value: subitem.id,
                      name: subitem.name
                    }
                  })
                }
              }else{
                 var fromrecos = that.recommendations.indexOf(subitem.id) > -1;
                 var fromselections = that.selections.indexOf(subitem.id) > -1;
                 if(subitem.name.toLowerCase().indexOf(that.searchterm.toLowerCase()) !== -1 && (fromrecos || that.showall || fromselections)){
                      return {
                        value: subitem.id,
                        name: subitem.name
                      }
                    }
              }
            }else{
              var out = _.compact(_.map(item[that.groupitems], function(subitem){
                  if(_.isUndefined(that.recommendations)){
                    if(subitem.name.toLowerCase().indexOf(that.searchterm.toLowerCase()) !== -1){
                      return {
                        value: subitem.id,
                        name: subitem.name
                      }
                    }
                  }else{
                    var fromrecos = that.recommendations.indexOf(subitem.id) > -1;
                    var fromselections = that.selections.indexOf(subitem.id) > -1;
                    if(subitem.name.toLowerCase().indexOf(that.searchterm.toLowerCase()) !== -1 && (fromrecos || that.showall || fromselections)){
                      return {
                        value: subitem.id,
                        name: subitem.name
                      }
                    }
                  }
              }));
              if(out.length > 0){
                return {
                  name: item.name,
                  items: out
                }
              }
            }
        }
        if(item instanceof String){
           if(item.toLowerCase().indexOf(that.searchterm.toLowerCase()) !== -1){
            return {
            }
           }
        }
      }
      );
      return _.compact(imts);

    },
    filteredItems: function() {
      if(this.items.length == 0){
        return [];
      }else{
        return _.map(this.items.filter(i => {
          if(i instanceof Object){
            var iname = ""
            if(_.isNull(i.name) == false) iname = i.name.toLowerCase();
            if(this.groupitems){
               iname = iname + _.map(i[this.groupitems], 'name').join(" ").toLowerCase();
            }
            return iname.indexOf(this.searchterm.toLowerCase()) !== -1;
          }else{
            return i.indexOf(this.searchterm.toLowerCase()) !== -1;
          }
        }), item => {
          if(item instanceof Object){
            return item;
          }
          if(_.isString(item)){
            return {
              name: item,
              value: item
            }
          }
        });
      }
    },
  }
}
</script>
<style scoped>
.searchterm{
  min-height: initial;
}
.searchterm input {
  margin: 0px;
  width: 95%;
}
.input-field{
  width: 100% !important;
}
.select-wrapper{
  width: 100% !important;
  margin-right: 0px !important;
  margin-left: 0px !important;
}
[type="checkbox"]:checked+span:not(.lever):before {
    border-right: 2px solid #000;
    border-bottom: 2px solid #000;
}
.dropdown-content p{
  margin-top: 0px;
  margin-bottom: 0px;
}
.elongating{
    border: 1px solid #9e9e9e;
    margin-bottom: 15px;
    border-radius: 4px;
    padding: 15px;
}
</style>
